<mat-card class="activity-form-card" *ngIf="test">
    <mat-card-content>
        <form #programForm [formGroup]="schoolActivityForm" class="activity-form">
            <div class="modal-header activity-form__header">
                <div class="row">
                    <div class="col-md-12">
                        <h5 class="modal-title">{{ 'EDIT_ACTIVITY' | translate }}</h5>
                    </div>
                </div>
            </div>
            <div class="activity-form__content">

                <div class="d-grid mb-2 form-field form-field--wide">
                    <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'ACTIVITY_NAME' | translate
                        }}<span style="font-size: 14px; color: rgb(190, 0, 0);">*</span></span>
                    <input class="form-control" type="text" placeholder="{{ 'ACTIVITY_NAME_PLACEHOLDER' | translate }}"
                        formControlName="activity_name" />
                </div>
                <div class="d-grid mb-4 form-field form-field--wide">
                    <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'ACTIVITY_DESCRIPTION' | translate
                        }}</span>
                    <textarea class="form-control" rows="3"
                        placeholder="{{ 'ACTIVITY_DESCRIPTION_PLACEHOLDER' | translate }}"
                        formControlName="activity_description"></textarea>
                </div>

                <div class="d-grid form-field form-field--wide">
                    <span style="font-size: 14px; font-weight: bold; color: #333">
                        {{ 'YEAR_LEVEL' | translate }}
                        <span style="font-size: 14px; color: rgb(190, 0, 0);">*</span>
                    </span>
                    <div class="row mb-2 year-level-options">
                        <div *ngFor="let year of yearLevelList" class="col-md-3">
                            <mat-checkbox mat-checkbox [checked]="year.checked" (change)="onChangeYearLevelByCheckbox($event, year)" [disabled]="true">
                                {{ year.description }}
                            </mat-checkbox>
                        </div>
                    </div>
                </div>

                <div class="d-grid mb-2 form-field form-field--wide">
                    <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'ACTIVITY_NAME_ON_REPORT_CARD' |
                        translate }}</span>
                    <input class="form-control" type="text"
                        placeholder="{{ 'ACTIVITY_NAME_ON_REPORT_CARD_PLACEHOLDER' | translate }}"
                        formControlName="name_on_report_card" />
                </div>

                <div class="d-grid mb-2 form-field form-field--wide">
                    <span style="font-size: 14px; font-weight: bold; color: #333;">Gender</span>
                    <div class="d-flex" style="gap: 16px;">
                        <mat-checkbox [checked]="schoolActivityForm.get('gender')?.value === 'all'" (change)="setGender('all')">All</mat-checkbox>
                        <mat-checkbox [checked]="schoolActivityForm.get('gender')?.value === 'M'" (change)="setGender('M')">Male</mat-checkbox>
                        <mat-checkbox [checked]="schoolActivityForm.get('gender')?.value === 'F'" (change)="setGender('F')">Female</mat-checkbox>
                    </div>
                </div>

                <div class="d-grid mb-4 d-flex p-0 justify-content-space-evenly form-field form-field--wide date-fields">
                    <div class="col-md-4 col-12">
                        <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'START_DATE' | translate
                            }}<span style="font-size: 14px; color: rgb(190, 0, 0);">*</span></span>
                        <input type="date" class="form-control" placeholder="{{ 'START_DATE_PLACEHOLDER' | translate }}"
                            formControlName="start_date" (change)="changeActivityDate()">
                        <span *ngIf="activityDateInvalid" style="font-size: 14px; color: rgb(190, 0, 0);">*{{
                            'START_DATE_ERROR' | translate }}</span>
                    </div>
                    <div class="col-md-4 col-12">
                        <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'END_DATE' | translate }}<span
                                style="font-size: 14px; color: rgb(190, 0, 0);">*</span></span>
                        <input type="date" class="form-control" placeholder="{{ 'END_DATE_PLACEHOLDER' | translate }}"
                            formControlName="end_date" (change)="changeActivityDate()">
                        <span *ngIf="activityDateInvalid" style="font-size: 14px; color: rgb(190, 0, 0);">*{{
                            'START_DATE_ERROR' | translate }}</span>
                    </div>
                    <div class="col-md-4 col-12">
                        <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'MAX_REGISTRATION_DATE' |
                            translate }}<span style="font-size: 14px; color: rgb(190, 0, 0);">*</span></span>
                        <input type="date" class="form-control"
                            placeholder="{{ 'MAX_REGISTRATION_DATE_PLACEHOLDER' | translate }}"
                            formControlName="max_registration_date" (change)="changeActivityDate()">
                        <span *ngIf="activityMaxRegistrationDateInvalid"
                            style="font-size: 14px; color: rgb(190, 0, 0);">*{{ 'MAX_REGISTRATION_DATE_ERROR' |
                            translate }}</span>
                    </div>
                </div>

                <!-- <div class="d-flex mb-2 align-items-center">
                    <label class="switch">
                        <input type="checkbox" (change)="onChangeActivityRuleBox()" formControlName="using_rule_per_year_level">
                        <span class="slider round"></span>
                    </label>
                    <div class="fs-6 ms-3">
                        {{ usingActivityRule ? 'Limit Per Year Level' : 'For All Year Level' }}
                    </div>
                </div> -->

                <div class="d-grid mb-2 form-field form-field--wide participant-fields">
                    <span style="font-size: 14px; font-weight: bold; color: #333;">
                        {{ 'MIN_MAX_PARTICIPANT' | translate }}
                        <span style="font-size: 14px; color: rgb(190, 0, 0);">*</span>
                    </span>
                    <div class="d-flex">
                        <div class="col-md-3 col-12 p-0 me-4">
                            <input class="form-control" type="number"
                                placeholder="{{ 'MIN_PARTICIPANT_PLACEHOLDER' | translate }}"
                                formControlName="min_participant" />
                        </div>
                        <div class="col-md-3 col-12 p-0 ms-4">
                            <input class="form-control" type="number"
                                placeholder="{{ 'MAX_PARTICIPANT_PLACEHOLDER' | translate }}"
                                formControlName="max_participant" />
                        </div>
                    </div>
                </div>

                <!-- <div class="d-grid mb-2" *ngIf="usingActivityRule">
                    <span class="mb-2" style="font-size: 14px; font-weight: bold; color: #333;">{{ 'MIN_MAX_PARTICIPANT' | translate }}<span style="font-size: 14px; color: rgb(190, 0, 0);">*</span></span>
                    <div formArrayName="rule_per_year_level" class="mb-2" *ngIf="this.schoolActivityForm.controls['school_location_id']?.value">
                        <div *ngFor="let year of ruleParticipantPerYearLevel.controls; let i = index" class="d-flex align-items-center mb-1" style="gap: 14px;" [formGroupName]="i">
                            <span class="col-md-1 text-end">{{ year.get('description')?.value || '-' }}</span>
                            <input class="form-control col-md-3" type="number" placeholder="{{ 'MIN_PARTICIPANT_PLACEHOLDER' | translate }}" formControlName="min_participant"/>
                            <input class="form-control col-md-3" type="number" placeholder="{{ 'MAX_PARTICIPANT_PLACEHOLDER' | translate }}" formControlName="max_participant"/>
                        </div>
                    </div>
                </div> -->

                <div class="d-grid mb-2 form-section form-field--wide">
                    <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'ACTIVITY_SCHEDULE' | translate
                        }}</span>

                    <div class="d-flex justify-content-between mb-2 row schedule-grid" formArrayName="activity_schedule">
                        <div *ngFor="let schedule of activitySchedule.controls; let i = index" class="col fixed-col"
                            [formGroupName]="i">

                            <mat-checkbox (change)="onChangeSchoolDayByCheckbox($event, i)"
                                [checked]="schedule.value.check">
                                {{ schedule.value.day }}
                            </mat-checkbox>

                            <div *ngIf="schedule.value.check" class="ps-3 py-1 block-day">
                                <div><strong>Day:</strong> {{ schedule.value.day }}</div>
                                <div class="align-items-center">
                                    <div class="inputschedule">
                                        <div class="mb-2">Start Time<input class="mb-2" class="input-schedule"
                                                type="time" formControlName="time_start"></div>
                                        <div class="mb-2">End Time<input class="mb-2" class="input-schedule" type="time"
                                                formControlName="time_end"></div>
                                        <div class="mb-2">Venue<input class="mb-2" class="input-schedule" type="text"
                                                formControlName="venue"></div>
                                        <div class="mb-2">Equipment<input class="mb-2" class="input-schedule"
                                                type="text" formControlName="equipment"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="d-grid mb-2 form-field">
                    <div class="d-flex mb-2 align-items-center">
                        <label class="switch">
                            <input type="checkbox" (change)="onToogleSessionOverride()" [checked]="sessionIsOverriden">
                            <span class="slider round"></span>
                        </label>
                        <div class="fs-6 ms-3">
                            {{ 'OVERRIDE_SESSION' | translate }}
                        </div>
                    </div>
                    <span style="font-size: 14px; font-weight: bold; color: #333;" *ngIf="!sessionIsOverriden">{{
                        'SESSIONS' | translate }}</span>
                    <span style="font-size: 14px; font-weight: bold; color: #333;" *ngIf="sessionIsOverriden">{{
                        'SESSION_OVERRIDEN' | translate }}</span>
                    <input class="form-control" type="number" formControlName="sessions" readonly
                        *ngIf="!sessionIsOverriden">
                    <input class="form-control" type="number" formControlName="session_override"
                        *ngIf="sessionIsOverriden">
                </div>

                <div class="d-grid mb-2 form-field">
                    <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'PARTICIPATION_FEE' | translate }}</span>
                    <span *ngIf="participantExists || disabledEditParticipant" style="font-size: 12px; color: red;">*you are not be able to change participation fee</span>
                    <input type="text" class="form-control" rows="3"
                        formControlName="participation_fee" mask="separator.0" thousandSeparator="." [readonly]="participantExists || disabledEditParticipant">
                </div>
                <div class="form-section form-field--wide score-section">
                <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'ACTIVITY_SCORE' | translate }}</span>

                <div class="d-flex mb-2 align-items-center">
                    <!-- <mat-checkbox (change)="onChangeScorePredicate()" [checked]="usingScoreRange">
                        {{ usingScoreRange ? ('PREDICATE_AND_SCORE' | translate) : ('PREDICATE_ONLY' | translate) }}
                    </mat-checkbox> -->
                    <label class="switch">
                        <input type="checkbox" (change)="onChangeScorePredicate()" [checked]="usingScoreRange">
                        <span class="slider round"></span>
                    </label>
                    <div class="fs-6 ms-3">
                        {{ usingScoreRange ?( 'PREDICATE_AND_SCORE' | translate) : ('PREDICATE_ONLY' | translate) }}
                    </div>
                </div>

                <div class="d-flex mb-2 align-items-center">
                    <label class="switch">
                        <input type="checkbox" (change)="onToggleAllScorePeriod()" [checked]="allScorePeriod">
                        <span class="slider round"></span>
                    </label>
                    <div class="fs-6 ms-3">
                        {{ 'ALL_PERIOD' | translate }}
                    </div>
                </div>

                <ng-template #scoreTable let-periodId="periodId">
                <div class="table-responsive"><table class="table table-bordered form-table">
                    <thead>
                        <tr>
                            <th rowspan="2">{{ 'SCORE_NAME' | translate }}</th>
                            <th [attr.colspan]="usingScoreRange ? 5 : 3">{{ 'SCORE_DETAIL' | translate }}</th>
                        </tr>
                        <tr>
                            <ng-container *ngIf="usingScoreRange">
                                <th>{{ 'MIN_SCORE' | translate }}<span class="text-danger">*</span></th>
                                <th>{{ 'MAX_SCORE' | translate }}<span class="text-danger">*</span></th>
                            </ng-container>
                            <th>{{ 'PREDICATE' | translate }}</th>
                            <th>{{ 'DESCRIPTION' | translate }}</th>
                            <th *ngIf="isScoreRangeMultiple" class="text-center">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngFor="let score of getScoreRange(periodId).controls; let i = index">
                            <ng-container *ngIf="score.get('deleted')?.value === false">
                                <tr>
                                    <td [attr.rowspan]="getRowspan(i, periodId)">
                                        <input type="text" class="form-control"
                                            [formControl]="convertToFormControl(score.get('score_name'))">
                                    </td>

                                    <ng-container *ngIf="getScoreRangeDetailByPeriod(i, periodId).length === 0">
                                        <td [attr.colspan]="usingScoreRange ? 5 : 3">No details</td>
                                    </ng-container>
                                </tr>

                                <ng-container *ngIf="getScoreRangeDetailByPeriod(i, periodId).length > 0">
                                    <tr *ngFor="let detail of getScoreRangeDetailByPeriod(i, periodId).controls; let j = index">
                                        <ng-container *ngIf="detail.get('deleted')?.value === false">
                                            <td *ngIf="usingScoreRange">
                                                <input type="number" class="form-control"
                                                    [formControl]="convertToFormControl(detail.get('minimum_score'))">
                                            </td>
                                            <td *ngIf="usingScoreRange">
                                                <input type="number" class="form-control"
                                                    [formControl]="convertToFormControl(detail.get('maximum_score'))">
                                            </td>
                                            <td>
                                                <input type="text" class="form-control"
                                                    [formControl]="convertToFormControl(detail.get('predicate'))">
                                            </td>
                                            <td>
                                                <input type="text" class="form-control"
                                                    [formControl]="convertToFormControl(detail.get('description'))">
                                            </td>
                                            <td *ngIf="getScoreRangeDetailByPeriod(i, periodId).length > 1" class="text-center">
                                                <button type="button" class="action-icon-btn action-icon-delete"
                                                    (click)="removeScoreDetail(i, j, periodId)"
                                                    aria-label="Remove detail" title="Remove detail">
                                                    <i class="fa fa-trash" aria-hidden="true"></i>
                                                </button>
                                            </td>
                                        </ng-container>
                                    </tr>

                                    <tr>
                                        <td [attr.colspan]="usingScoreRange ? 6 : 4" class="w-full">
                                            <div class="d-flex flex-row justify-content-between mb-4 px-2">
                                                <button type="button" class="action-btn action-btn-delete me-4" (click)="removeScore(i, periodId)"
                                                    *ngIf="getScoreRange(periodId).length > 1">- Remove Score</button>
                                                <button type="button" class="action-icon-btn action-icon-edit"
                                                    (click)="addScoreDetail(i, periodId)"
                                                    aria-label="Add detail" title="Add detail">
                                                    <i class="fa fa-plus" aria-hidden="true"></i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                </ng-container>
                            </ng-container>
                        </ng-container>
                    </tbody>
                </table></div>

                <div class="mt-2 mb-4">
                    <button type="button" class="action-btn action-btn-create me-2" (click)="addScore(periodId)">+ {{ 'ADD_SCORE' | translate
                        }}</button>
                </div>
                </ng-template>

                @if (allScorePeriod) {
                    <ng-container *ngTemplateOutlet="scoreTable; context: { periodId: null }"></ng-container>
                } @else {
                    <mat-tab-group *ngIf="periodList.length > 0">
                        @for (period of periodList; track period.period_id) {
                            <mat-tab [label]="period.name">
                                <div class="mt-4">
                                    <ng-container *ngTemplateOutlet="scoreTable; context: { periodId: period.period_id }"></ng-container>
                                </div>
                            </mat-tab>
                        }
                    </mat-tab-group>
                }

                </div>

                <div class="d-grid mb-2 form-section form-field--wide">
                    <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'ACTIVITY_FEE' | translate
                        }}</span>
                    <div class="table-responsive"><table class="table table-striped table-bordered form-table">
                        <thead>
                            <tr>
                                <th>{{ 'COACH_ASSISTANT_FEE' | translate }}</th>
                                <th>{{ 'EQUIPMENT_FEE' | translate }}</th>
                                <th>{{ 'VENUE_FEE' | translate }}</th>
                                <th>{{ 'OTHER_FEE' | translate }}</th>
                                <th>{{ 'TOTAL_FEE' | translate }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <input type="text" class="form-control" (change)="onChangeFees()"
                                        formControlName="coach_fee" mask="separator.0" thousandSeparator=".">
                                </td>
                                <td>
                                    <input type="text" class="form-control" (change)="onChangeFees()"
                                        formControlName="equipment_fee" mask="separator.0" thousandSeparator=".">
                                </td>
                                <td>
                                    <input type="text" class="form-control" (change)="onChangeFees()"
                                        formControlName="venue_fee" mask="separator.0" thousandSeparator=".">
                                </td>
                                <td>
                                    <input type="text" class="form-control" (change)="onChangeFees()"
                                        formControlName="other_fee" mask="separator.0" thousandSeparator=".">
                                </td>
                                <td>
                                    <input type="text" class="form-control" [(ngModel)]="totalFee"
                                        [ngModelOptions]="{standalone: true}" mask="separator.0" thousandSeparator="."
                                        readonly>
                                </td>
                            </tr>
                        </tbody>
                    </table></div>
                </div>

                <div class="person-role-row form-field--wide">
                    <div class="d-flex mb-2 align-items-center toggle-row">
                    <!-- <mat-checkbox (change)="switchSupervisor()" [checked]="supervisor">
                      {{ 'SUPERVISOR' | translate }}
                  </mat-checkbox> -->
                    <label class="switch">
                        <input type="checkbox" (change)="switchSupervisor()" [checked]="supervisor">
                        <span class="slider round"></span>
                    </label>
                    <div class="fs-6 ms-3">
                        {{ 'SUPERVISOR' | translate }}
                    </div>
                    </div>

                    <div class="person-role-selector" *ngIf="supervisor">
                    <div class="person-role-selector__label">
                        <span>{{ 'SUPERVISOR' | translate }}</span>
                        <small>Assign one or more supervisors</small>
                    </div>
                    <div [formGroup]="schoolActivityForm">
                        <ng-select [items]="supervisorList" bindLabel="staff_name"
                            bindValue="staff_id" [selectableGroup]="false" [multiple]="true"
                            [closeOnSelect]="false" [clearable]="true" [searchable]="true"
                            placeholder="Search and select supervisors" formControlName="supervisor"
                            class="selector-style person-role-selector__control">
                            <ng-template ng-option-tmp let-item="item">
                                <div class="custom-option-style">
                                    {{ item.staff_name }}
                                </div>
                            </ng-template>
                        </ng-select>
                    </div>
                    </div>
                </div>

                <div class="person-role-row form-field--wide">
                    <div class="d-flex mb-2 align-items-center toggle-row">
                    <!-- <mat-checkbox (change)="switchCoach()" [checked]="coach">
                        {{ 'COACH' | translate }}
                    </mat-checkbox> -->
                    <label class="switch">
                        <input type="checkbox" (change)="switchCoach()" [checked]="coach">
                        <span class="slider round"></span>
                    </label>
                    <div class="fs-6 ms-3">
                        {{ 'COACH' | translate }}
                    </div>
                    </div>

                    <div class="person-role-selector" *ngIf="coach">
                    <div class="person-role-selector__label">
                        <span>{{ 'COACH' | translate }}</span>
                        <small>Assign one or more coaches</small>
                    </div>
                    <div [formGroup]="schoolActivityForm">
                        <ng-select [items]="coachList" bindLabel="fullname"
                            bindValue="user_id" [selectableGroup]="false" [multiple]="true" formControlName="coach"
                            [closeOnSelect]="false" [clearable]="true" [searchable]="true"
                            placeholder="Search and select coaches" class="selector-style person-role-selector__control">
                            <ng-template ng-option-tmp let-item="item">
                                <div class="custom-option-style">
                                    {{ item.fullname }}
                                </div>
                            </ng-template>
                        </ng-select>
                    </div>
                    </div>
                </div>

                <div class="status-selector form-field">
                    <div class="status-selector__label">
                        <span>{{ 'STATUS' | translate }} <b aria-hidden="true">*</b></span>
                        <small>Choose the activity availability</small>
                    </div>
                    <div [formGroup]="schoolActivityForm">
                        <ng-select [items]="statusList" [selectableGroup]="false"
                            formControlName="status" [clearable]="false" [searchable]="false"
                            class="selector-style status-selector__control">
                            <ng-template ng-label-tmp let-item="item">
                                <span class="status-dot" [ngClass]="'status-dot--' + (item | lowercase)"></span>
                                {{ item }}
                            </ng-template>
                            <ng-template ng-option-tmp let-item="item">
                                <div class="custom-option-style status-option">
                                    <span class="status-dot" [ngClass]="'status-dot--' + (item | lowercase)"></span>
                                    {{ item }}
                                </div>
                            </ng-template>
                        </ng-select>
                    </div>
                </div>

                <!-- <div class="d-grid mb-2">
                  <span style="font-size: 14px; font-weight: bold; color: #333;">{{ 'APPROVER' | translate }}</span>
                  <div [formGroup]="schoolActivityForm">
                      <ng-select (change)="onChangeApprover($event)"
                                  [items]="approverList"
                                  bindLabel="fullname"
                                  bindValue="user_id"  
                                  [selectableGroup]="false"
                                  formControlName="user_id_approver"
                                  class="selector-style">
                                  <ng-template ng-option-tmp let-item="item">
                                      <div class="custom-option-style">
                                          {{ item.fullname }}
                                      </div>
                                  </ng-template>
                      </ng-select>
                  </div>
              </div> -->

                <div class="d-grid form-field--wide">      
                    <div class="mb-4">
                        <span style="font-size: 14px; font-weight: bold; color: #333;" class="form-field--wide">{{ 'Manage Participant' | translate }}</span>
                        <div class="form-field--wide participant-notice">
                            <span *ngIf="disabledEditParticipant" style="font-size: 12px; color: red;">*you are not be able to add/remove participant because activity registration period is open</span>
                        </div>
                    </div>
                </div>

                <div class="mb-3 form-field--wide" *ngIf="periodList.length > 0">
                    <mat-tab-group>
                        @for (period of periodList; track period.period_id) {
                            <mat-tab [label]="period.name">
                                <div class="mt-3">
                                    <span class="fw-bold">{{ 'REGISTERED_STUDENT' | translate }}:</span>
                                </div>
                                <div class="table-responsive table-list-wrapper table-fixed mb-2"
                                    *ngIf="registeredStudentsByPeriod[period.period_id] && registeredStudentsByPeriod[period.period_id].length > 0">
                                    <table class="table table-list">
                                        <thead style="font-size: 12px">
                                            <tr>
                                                <th>No</th>
                                                <th>Student Id</th>
                                                <th>Class Name</th>
                                                <th>Student Name</th>
                                                <th>Participated & Paid</th>
                                                <th *ngIf="auth.permissions['SCHOOL_PROGRAM_PARTICIPANT_DELETE'] && !disabledEditParticipant">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody style="font-size: 12px">
                                            <tr *ngFor="let item of registeredStudentsByPeriod[period.period_id]; let i = index;" class="col-md-12">
                                                <td class="text-center col-md-1">{{ (i + 1) }}</td>
                                                <td class="text-center col-md-2">{{ item.nis }}</td>
                                                <td class="text-center col-md-2">{{ item.class_name }}</td>
                                                <td class="text-center col-md-4">{{ item.student_name }}</td>
                                                <td class="text-center col-md-1">
                                                    <i *ngIf="item.is_paid" class="fa fa-check-circle text-success"></i>
                                                    <i *ngIf="!item.is_paid" class="fa fa-times-circle text-danger"></i>
                                                </td>
                                                <td class="text-center col-md-3"
                                                    *ngIf="auth.permissions['SCHOOL_PROGRAM_PARTICIPANT_DELETE'] && !disabledEditParticipant">
                                                    <span class="link text-danger font-weight-bold mx-1 cursor-pointer"
                                                        (click)="onRemoveParticipant(item.student_id, period.period_id)">
                                                        {{ isRemovedParticipant(item.student_id, period.period_id) ? "Undo" : "Remove" }}
                                                    </span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div>
                                    <app-status-no-data
                                        [show]="!loadingRegisteredByPeriod[period.period_id] && (!registeredStudentsByPeriod[period.period_id] || registeredStudentsByPeriod[period.period_id].length === 0)">
                                    </app-status-no-data>
                                    <app-status-loading
                                        [show]="loadingRegisteredByPeriod[period.period_id]">
                                    </app-status-loading>
                                </div>

                                <div *ngIf="!disabledEditParticipant">
                                    <button
                                        *ngIf="$first"
                                        type="button"
                                        class="action-btn action-btn-create"
                                        (click)="openCopyToOtherPeriodModal(copyToOtherPeriodModal)">
                                        Copy To Other Period
                                    </button>
                                </div>

                                <div *ngIf="!disabledEditParticipant">
                                    <div class="mb-2 mt-4">
                                        <span class="fw-bold">{{ 'UNREGISTERED_STUDENT' | translate }}:</span>
                                    </div>
                                    <div class="mt-2 mb-2" *ngIf="activityId">
                                        <app-table-participant
                                            [schoolProgramActivityId]="activityId"
                                            [academicYear]="detail?.activity?.academic_year"
                                            [yearLevelId]="selectedYearLevelIds"
                                            [schoolLocationId]="detail?.activity?.school_location_id"
                                            [periodId]="period.period_id"
                                            [gender]="schoolActivityForm.get('gender')?.value"
                                            [canSelect]="auth.permissions['SCHOOL_PROGRAM_PARTICIPANT_ADD'] && !disabledEditParticipant"
                                            (checkedParticipantsChange)="onCheckedParticipantsChange($event, period)">
                                        </app-table-participant>
                                    </div>
                                </div>
                            </mat-tab>
                        }
                    </mat-tab-group>
                </div>

                <div class="form-actions form-field--wide">
                    <button class="gradient-button mt-3 me-1" type="button" (click)="onBack()">Cancel</button>
                    <button
                        class="gradient-button mt-3 me-1"
                        [disabled]="disableButtonEdit"
                        (click)="onSubmitEdit()"
                        type="button"
                        *ngIf="auth.permissions['SCHOOL_PROGRAM_PARTICIPANT_ADD'] || auth.permissions['SCHOOL_PROGRAM_PARTICIPANT_DELETE'] || auth.permissions['SCHOOL_PROGRAM_ACTIVITY_EDIT']"
                    >Save</button>
                </div>
            </div>
        </form>
    </mat-card-content>
</mat-card>

<ng-template #copyToOtherPeriodModal let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="copy-to-other-period-title">Copy To Other Period</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body">
        <p>Select the periods that should receive the registered students from {{ periodList[0]?.name }}.</p>
        <div class="form-check mb-2" *ngFor="let period of periodList.slice(1)">
            <input
                class="form-check-input"
                type="checkbox"
                [id]="'copy-period-' + period.period_id"
                [checked]="isCopyPeriodSelected(period.period_id)"
                (change)="toggleCopyPeriod(period.period_id, $any($event.target).checked)">
            <label class="form-check-label" [for]="'copy-period-' + period.period_id">
                {{ period.name }}
            </label>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" [disabled]="copyingRegisteredReport" (click)="modal.dismiss()">Cancel</button>
        <button
            type="button"
            class="gradient-button"
            [disabled]="copyingRegisteredReport || selectedCopyPeriodIds.length === 0"
            (click)="copyRegisteredReport(modal)">
            {{ copyingRegisteredReport ? 'Saving...' : 'Save' }}
        </button>
    </div>
</ng-template>
